import React from "react";

export interface IAppContext {
    isLoading: boolean;
    activePage: string;
    loadedChanged: (isLoading: boolean, pageId?: string) => Promise<void>;
}

export const AppContext = React.createContext<IAppContext>({
    isLoading: false,
    activePage: "",
    loadedChanged: () => new Promise(() => {})
});